import React, { useContext } from 'react';
import { AuthContext } from 'contexts';
import AnsweringServiceContext, {
  AnsweringServiceSubscribeStep,
} from './AnsweringServiceContext';
import LearnMore from './LearnMore';
import PaymentConfirmation from './PaymentConfirmation';
import SubscriptionSuccess from './SubscriptionSuccess';
import { StyledBodyPane } from './StyledComponents';
import ManageListings from './ManageListings';
import AnsweringServiceError from './AnsweringServiceError';
import StyledLoading from './components/StyledLoading';

/**
 * The main UI page, wrapped by the Answering Service Context,
 * to house the content for the user managing their Answering Service.
 * Displays different content depending on how far along they are in the
 * subscription process.
 */
const AnsweringServiceLayout: React.FC = () => {
  const {
    currentStep,
    fetchingSubscription,
    fetchingBillingInfo,
    loadingLegacyStatus,
  } = useContext(AnsweringServiceContext);
  const { answeringPortalConfigError, loadingAnsweringPortalConfig } =
    useContext(AuthContext);

  if (
    loadingAnsweringPortalConfig ||
    loadingLegacyStatus ||
    fetchingBillingInfo ||
    fetchingSubscription
  ) {
    return <StyledLoading />;
  }

  if (answeringPortalConfigError) {
    return <AnsweringServiceError />;
  }

  return (
    <StyledBodyPane>
      {currentStep === AnsweringServiceSubscribeStep.LearnMore && <LearnMore />}
      {currentStep === AnsweringServiceSubscribeStep.ManageListings && (
        <ManageListings />
      )}
      {currentStep === AnsweringServiceSubscribeStep.PaymentConfirmation && (
        <PaymentConfirmation />
      )}
      {currentStep === AnsweringServiceSubscribeStep.SubscriptionSuccess && (
        <SubscriptionSuccess />
      )}
    </StyledBodyPane>
  );
};

export default AnsweringServiceLayout;
